import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["children"];

var _templateObject;

import React from "react";
import { Box, Flex, IconOnePassBg } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var BgIcon = styled(IconOnePassBg)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mix-blend-mode: overlay;\n"])));
export var OnePassHeader = function OnePassHeader(_ref) {
  var children = _ref.children,
      flexProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Flex, _extends({
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: "30px",
    color: "textWhite",
    overflow: "hidden",
    fontFamily: "onePass",
    backgroundColor: "onePass.primaryDarker"
  }, flexProps), children, ___EmotionJSX(Box, {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%"
  }, ___EmotionJSX(BgIcon, {
    name: "OnePass background",
    fill: "white",
    width: "auto",
    height: "110%",
    opacity: 0.5
  })));
};
export default OnePassHeader;